module.exports = __webpack_public_path__ + "static/media/Features 4.7e546772.svg";